import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ClipboardListIcon } from 'lucide-react';
import { useEstimate } from '../contexts/EstimateContext';
export function FloatingEstimateButton() {
  const {
    openEstimate
  } = useEstimate();
  const reduce = useReducedMotion();
  return <motion.div className="fixed bottom-4 right-4 z-[1150] sm:bottom-6 sm:right-6" initial={reduce ? false : {
    opacity: 0,
    scale: 0.96,
    y: 8
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    duration: 0.25,
    ease: [0.23, 1, 0.32, 1],
    delay: 0.4
  }} data-id="element-167" data-mp="1gq4zzk8iavea">
      {!reduce && <>
          <motion.span aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-full bg-brick" animate={{
        scale: [1, 1.35],
        opacity: [0.45, 0]
      }} transition={{
        duration: 1.4,
        ease: 'easeOut',
        repeat: Infinity,
        repeatDelay: 1.2
      }} data-id="element-168" data-mp="1218w7zdhg4jh" />
          <motion.span aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-full bg-brick" animate={{
        scale: [1, 1.35],
        opacity: [0.3, 0]
      }} transition={{
        duration: 1.4,
        ease: 'easeOut',
        repeat: Infinity,
        repeatDelay: 1.2,
        delay: 0.35
      }} data-id="element-169" data-mp="o17s8b1x8gzs" />
        </>}
      <motion.button type="button" onClick={() => openEstimate()} animate={reduce ? undefined : {
      rotate: [0, -3, 3, -2, 0]
    }} transition={{
      duration: 0.5,
      ease: 'easeInOut',
      repeat: Infinity,
      repeatDelay: 4
    }} whileHover={{
      scale: 1.04
    }} whileTap={{
      scale: 0.97
    }} className="relative inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-brick py-1.5 pl-1.5 pr-4 text-sm font-bold text-white shadow-xl shadow-brick/40 ring-2 ring-white transition-colors duration-150 hover:bg-brick-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brick" data-id="element-170" data-mp="2ji3aejatqkux">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-brick" data-id="element-171" data-mp="1rs8mmr2m738d">
          <ClipboardListIcon className="h-4 w-4" aria-hidden="true" data-id="element-172" data-mp="3tfbj895tp3sa" />
        </span>
        Get Estimate
        <span className="rounded-full bg-[#ffd447] px-1.5 py-0.5 text-[10px] font-extrabold leading-none text-ink" data-id="element-173" data-mp="3oj34uxzg9em6">
          FREE
        </span>
      </motion.button>
    </motion.div>;
}